





































import { Component, Vue, ProvideReactive } from 'vue-property-decorator';
import AmeldingList from './AmeldingList.vue';
import { GQL_currentUnit, GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import { SmartQuery } from 'vue-apollo-decorator';
import { CURRENT_UNIT } from '@/queries/Application';
import paycheckSettingsService from '@/utils/paycheck-settings-service';
import PermissionService from '@/utils/permission-service';
import { periodYears } from '@/app/paycheck-period';

@Component({
  components: {
    AmeldingList,
  },
})
export default class Ameldings extends Vue {
  @SmartQuery<AmeldingList, GQL_currentUnit>({
    query: CURRENT_UNIT,
  }) private currentUnit?: GQL_currentUnit_currentUnit;

  private years: number[] = [];
  private paycheckSettingsService = paycheckSettingsService;

  async created() {
    this.years = await periodYears();
  }

  @ProvideReactive()
  private get editable(): boolean {
    return PermissionService.check('canSendAltinnPaycheckReports');
  }
}
